<template>
    <div class="wrapper">
        <div class="swiper-container" v-if="listInfo">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item,index) in listInfo" :key="item+index"><img :src="item" alt="图片"></div>
            </div>
            <!-- 如果需要分页器 -->
            <div class="swiper-pagination"></div>
        </div>
    </div>
</template>
<script>
export default{
    props:['listInfo'],
    data(){
        return{
            swiper:null
        }
    },
    watch:{
        listInfo(){
            this.$nextTick(function(){
                this.getSwiper()
            })
        }
    },
    methods:{
        getSwiper(){
            this.swiper = new Swiper ('.swiper-container', {
                autoplay:3000,
                loop:true,
                slidesPerView : 3,
                spaceBetween : '3%',   
                pagination: '.swiper-pagination',
                paginationClickable: true,
                breakpoints: { 
                    //当宽度小于等于320
                    768: {
                    slidesPerView: 1
                    },
                //当宽度小于等于480
                    1200: { 
                    slidesPerView: 2
                    }
                }      
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.wrapper{
    width: 100%;
    padding: 40px 0;
    background-color: #F0F2F5;
    margin-bottom: 100px;
    .swiper-container{
        width: 100%;
        overflow: hidden;
        .swiper-slide{
            width: 100%;
            img{
                width: 100%;
            }
        }
    }
} 
</style>


// WEBPACK FOOTER //
// src/components/department/swiper.vue